module.exports = "/assets/556071b3822437975e39ac1df45d28fa.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/JV.png
// module id = 2648
// module chunks = 0